import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'antd';

const style = {
  button: {
    width: '100%',
  },
};

const Buttons = ({ back }) => {
  return (
    <Row gutter={10}>
      <Col span={12} offset={12}>
        <Button onClick={back} style={style.button} data-test="back">
          Back
        </Button>
      </Col>
    </Row>
  );
};

Buttons.propTypes = {
  back: PropTypes.func.isRequired,
};

export default Buttons;
